class FFFaqPage extends HTMLElement {
  connectedCallback() {
    this.navButtons = Array.from(this.querySelectorAll('.ff-faq-page__nav-btn'));
    this.groups = Array.from(this.querySelectorAll('.ff-faq-page__group'));
    this.details = Array.from(this.querySelectorAll('.ff-faq-page__details'));
    this.singleOpen = this.dataset.singleOpen !== 'false';

    if (this.navButtons.length && this.groups.length) {
      this.navButtons.forEach((btn) => {
        btn.addEventListener('click', () => this.scrollToGroup(btn.dataset.target));
      });

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              this.setActiveNav(entry.target.id);
            });
          },
          { rootMargin: '-20% 0px -60% 0px', threshold: 0 }
        );
        this.groups.forEach((group) => this.observer.observe(group));
      } else if (this.groups[0]) {
        this.setActiveNav(this.groups[0].id);
      }
    }

    if (this.singleOpen && this.details.length) {
      this.details.forEach((detail) => {
        detail.addEventListener('toggle', () => {
          if (!detail.open) return;
          this.details.forEach((other) => {
            if (other !== detail && other.open) other.open = false;
          });
        });
      });
    }
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  scrollToGroup(id) {
    const target = this.querySelector(`#${id}`);
    if (!target) return;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    this.setActiveNav(id);
  }

  setActiveNav(id) {
    this.navButtons.forEach((btn) => {
      btn.classList.toggle('is-active', btn.dataset.target === id);
    });
  }
}

customElements.define('ff-faq-page', FFFaqPage);
